__turbopack_context__.v({
  "textarea": "PlasmicTextarea-module__O_FJPa__textarea",
  "textareadisabled": "PlasmicTextarea-module__O_FJPa__textareadisabled",
  "textareainvalid": "PlasmicTextarea-module__O_FJPa__textareainvalid",
  "textareasize_small": "PlasmicTextarea-module__O_FJPa__textareasize_small",
});
